
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_14908_487939)"}},[_c('path',{attrs:{"fill":"#545C69","d":"M0 .988h7v7H0z"}}),_c('path',{attrs:{"stroke":"#545C69","stroke-width":".875","d":"M0 .988h7v7H0zM7 .988h7v7H7zM0 7.988h7v7H0zM7 7.988h7v7H7z"}})]),_c('rect',{attrs:{"x":".5","y":"1.488","width":"13","height":"13","rx":"1.25","stroke":"#545C69"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_14908_487939"}},[_c('rect',{attrs:{"y":".988","width":"14","height":"14","rx":"1.75","fill":"#fff"}})])])])
          )
        }
      }
    